import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MoverModuleEntity } from './mover-module.entity';
import { MoverEntity } from './mover.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('_fk__mover__id', ['fkMoverId'], {})
@Index('_fk__mover_module__id', ['fkMoverModuleId'], {})
@Index('_fk__rbac_role__id', ['fkRbacRoleId'], {})
@Entity('_mover__rbac_role')
export class MoverRbacRoleEntity extends BaseEntity {
	@Column('int', { name: '_fk__mover__id', nullable: true, unsigned: true })
	public fkMoverId!: number | null;

	@Column('int', { name: '_fk__rbac_role__id', nullable: true, unsigned: true })
	public fkRbacRoleId!: number | null;

	@Column('int', {
		name: '_fk__mover_module__id',
		nullable: true,
		unsigned: true,
	})
	public fkMoverModuleId!: number | null;

	@Column('smallint', { name: '_sortOrder' })
	public sortOrder!: number;

	@Column('longtext', { name: '_workdComponentInputOverrides', nullable: true })
	public workdComponentInputOverrides!: string | null;

	@Column('longtext', { name: '_countQueryOverrides', nullable: true })
	public countQueryOverrides!: string | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('longtext', { name: '_stateRangesOverride', nullable: true })
	public stateRangesOverride!: string | null;

	@ManyToOne(() => MoverEntity, (mover) => mover.moverRbacRoles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__mover__id', referencedColumnName: 'id' }])
	public fkMover!: MoverEntity;

	@ManyToOne(() => RbacRoleEntity, (rbacRole) => rbacRole.moverRbacRoles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;

	@ManyToOne(
		() => MoverModuleEntity,
		(moverModule) => moverModule.moverRbacRoles,
		{
			onDelete: 'NO ACTION',
			onUpdate: 'NO ACTION',
		},
	)
	@JoinColumn([{ name: '_fk__mover_module__id', referencedColumnName: 'id' }])
	public fkMoverModule!: MoverModuleEntity;
}
